(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/invitation/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/invitation/assets/javascripts/constants.js');

'use strict';

const CompetitionType = Object.freeze({
  SPELA_TILLSAMMANS: 'competitionType/spelaTillsammas',
  TIPS_SM: 'competitionType/tipsSM'
});
const CompetitionErrorCode = Object.freeze({
  NOT_USED: 0,
  DEFAULT: 3,
  COMPETITION_NOT_FOUND: 101,
  ACTIVE_COMPETITION_NOT_OK: 102,
  ACTIVE_BET_NOT_OK: 103,
  CUSTOMER_SUSPENDED: 104,
  SIGNUP_REQUIRED: 105,
  SIGNUP_TO_EARLY: 106,
  MEMBER_IN_MAX_TEAMS: 107,
  TEAM_NAME_NOT_UNIQUE: 108,
  INVITATION_ID_NOT_FOUND: 109,
  ALREADY_PARTICIPATE: 110,
  NO_MORE_MEMBERS: 111,
  TEAM_NOT_FOUND: 112,
  HIGHEST_ERRCODE: 113
});
if (svs.isServer) {
  module.exports = {
    CompetitionType,
    CompetitionErrorCode
  };
} else {
  setGlobal('svs.components.marketplaceShared.invitation.CompetitionType', CompetitionType);
  setGlobal('svs.components.marketplaceShared.invitation.CompetitionErrorCode', CompetitionErrorCode);
}

 })(window);